module.exports = __webpack_public_path__ + "media/common/icon-missing-413f94bc.svg";